import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import CreateTaskOwnerLabel from 'automation-ui-action-features/actions/create-task/CreateTaskOwnerLabel';
import CreateTaskTitleLabel from 'automation-ui-action-features/actions/create-task/CreateTaskTitleLabel';
import { jsx as _jsx } from "react/jsx-runtime";
export default function CreateTaskActionExplainer({
  action,
  flowObjectTypeId
}) {
  const metadata = action.metadata;
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "automation-ui-action-features.action-features.create-task.explainer",
    options: {
      owner: /*#__PURE__*/_jsx(CreateTaskOwnerLabel, {
        actionMetadata: metadata,
        flowObjectTypeId: flowObjectTypeId
      }),
      subject: /*#__PURE__*/_jsx("strong", {
        children: /*#__PURE__*/_jsx(CreateTaskTitleLabel, {
          actionMetadata: metadata,
          flowObjectTypeId: flowObjectTypeId
        })
      })
    }
  });
}